/*jshint esversion: 8 */
import React, { Component } from "react";
// import clsx from  'clsx';

import PropTypes from "prop-types";
import { observer } from "mobx-react";

import { withStyles } from "@material-ui/core/styles";
// import { makeStyles } from '@material-ui/core/styles';
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TablePagination from "@material-ui/core/TablePagination";
import TableRow from "@material-ui/core/TableRow";
import TableSortLabel from "@material-ui/core/TableSortLabel";
import Paper from "@material-ui/core/Paper";
import ButtonGroup from "@material-ui/core/ButtonGroup";
import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";

import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Select from "@material-ui/core/Select";
import MenuItem from "@material-ui/core/MenuItem";

import { toJS } from "mobx";

import CheckHandler from "../../../utils/CheckHandler";
import ITextField from "../../../components/UI/ITextField";

import store from "../../../components/stores/Store";

import {
  deleteRoom,
  updateRoom,
  publishRoom,
  recallRoom,
} from "../../../db/RoomRequestHandler";
import { getIfFuncAuthorized } from "../../../utils/CheckSomething";

// import { CheckSomething } from '../../../utils/CheckSomething';

const styles = {
  root: {
    width: "100%",
  },
  paper: {
    width: "100%",
    // marginBottom: theme.spacing(2),
  },
  tableContainer: {
    // maxHeight: "450px", // todo
    maxWidth: "100%", // todo
  },
  table: {
    minWidth: 750,
  },
  visuallyHidden: {
    border: 0,
    clip: "rect(0 0 0 0)",
    height: 1,
    margin: -1,
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    top: 20,
    width: 1,
  },
  TableCell: {
    paddingLeft: "4px",
    paddingRight: "4px",
    borderRight: 'solid',
    borderRightColor: '#eee'
  },
};
// TableOfRoomManagement
class TableOfRoomManagementInner extends Component {
  constructor() {
    super();
    store.setOrderByOfTableConfig("createdate"); // 定制
    store.setOrderOfTableConfig("desc");
    this.state = {
      updateDialogOpen: false,
      updateDialogParams: {},
      tableContainerHeight: '500px',
      deleteLineDialogOpen: false,
      toDeleteId: '',
    };

    // 通用
    this.descendingComparator = this.descendingComparator.bind(this);
    this.getComparator = this.getComparator.bind(this);
    this.stableSort = this.stableSort.bind(this);
    this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    this.handleChangePage = this.handleChangePage.bind(this);
    this.sortHandler = this.sortHandler.bind(this);
    this.handleSelectAllClick = this.handleSelectAllClick.bind(this);
    this.isSelected = this.isSelected.bind(this);
    this.handleCheckClick = this.handleCheckClick.bind(this);

    // 定制
    this.publishRoom = this.publishRoom.bind(this);
    this.recallRoom = this.recallRoom.bind(this);
    this.openUpdateLineDialog = this.openUpdateLineDialog.bind(this);
    this.onUpdateDialogParamsChange =
      this.onUpdateDialogParamsChange.bind(this);
    this.closeUpdateDialog = this.closeUpdateDialog.bind(this);
    this.updateLine = this.updateLine.bind(this);
    this.calcSize = this.calcSize.bind(this);
    this.deleteLine = this.deleteLine.bind(this);
    this.closeDeleteLineDialog = this.closeDeleteLineDialog.bind(this);
    this.openDeleteLineDialog  = this.openDeleteLineDialog.bind(this);
  }

  async componentDidMount() {
    this.calcSize();
  }
  componentWillUnmount() { }

  // 通用
  isSelected(id) {
    return store.linesSelected.indexOf(id) !== -1;
  }

  calcSize() {
    // const innerWidth  = window.innerWidth;
    const innerHeight = window.innerHeight;
    this.setState({
      tableContainerHeight: `${innerHeight - 250}px`,
    });
  }

  // 通用
  descendingComparator(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  // 通用
  handleSelectAllClick(event) {
    console.log(`----- handleSelectAllClick`);
    if (event.target.checked) {
      const newSelecteds = store.table.map((n) => n.ID);
      store.setLinesSelected(newSelecteds);
      return;
    }
    store.setLinesSelected([]);
  }

  // 通用
  stableSort(array, comparator) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = comparator(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  // 通用
  getComparator(order, orderBy) {
    return order === "desc"
      ? (a, b) => this.descendingComparator(a, b, orderBy)
      : (a, b) => -1 * this.descendingComparator(a, b, orderBy);
  }

  // 通用
  handleChangePage(event, newPage) {
    //  console.log(`----- handleChangePage-newPage: `, newPage);
    // this.setState({page: newPage});
    store.setCurrentPageOfTableConfig(newPage);
    store.search();
  }

  // 通用
  handleChangeRowsPerPage(event) {
    store.setRowsPerPageOfTableConfig(parseInt(event.target.value, 10));
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  sortHandler(event, header) {
    if (!header.sortable) return;
    const orderBy = header.id;
    const order   = (orderBy === store.tableConfig.orderBy && store.tableConfig.order === 'asc') ? 'desc' : 'asc';
    store.setOrderOfTableConfig(order);
    store.setOrderByOfTableConfig(orderBy);
    store.setCurrentPageOfTableConfig(0);
    store.search();
  }

  // 通用
  handleCheckClick(event, id) {
    console.log(`----- handleCheckClick-id: `, id);
    const selectedIndex = store.linesSelected.indexOf(id);
    let newSelected = [];
    console.log(`----- handleCheckClick-selectedIndex: `, selectedIndex);

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(store.linesSelected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(store.linesSelected.slice(1));
    } else if (selectedIndex === store.linesSelected.length - 1) {
      newSelected = newSelected.concat(store.linesSelected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        store.linesSelected.slice(0, selectedIndex),
        store.linesSelected.slice(selectedIndex + 1)
      );
    }
    console.log(`----- handleCheckClick-newSelected: `, newSelected);

    store.setLinesSelected(newSelected);
  }
  
  closeDeleteLineDialog() {
    this.setState({
      toDeleteId: '',
      deleteLineDialogOpen: false,
    });
  }

  openDeleteLineDialog(e, id) {
    this.setState({
      toDeleteId: id,
      deleteLineDialogOpen: true,
    });
  }

  async deleteLine() {
    const id = this.state.toDeleteId;
    this.closeDeleteLineDialog();
    console.log(`----- send req of deleteLine`);
    const rst = await deleteRoom({ ID: id });
    //  console.log(`----- deleteRoom rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "删除错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "删除成功");
      store.search();
      return true;
    }
  }

  async openUpdateLineDialog(e, irow) {
    const row = toJS(irow);
    console.log(`----- openUpdateLineDialog-row: `, row);
    this.setState({
      updateDialogOpen: true,
      updateDialogParams: {
        ID: row.ID,
        developerId: row.developerId,
        propertyName: row.propertyName,
        buildingNo: row.buildingNo,
        unit: row.unit,
        floor: row.floor,
        roomNumber: row.roomNumber,
        houseType: row.houseType,
        buildingArea: row.buildingArea,
        recordPrice: row.recordPrice,
        totalPrice: row.totalPrice,
        maximumPrice: row.maximumPrice,
        totalPrice2: row.totalPrice2,
        remarks: row.remarks,
      },
    });
  }

  onUpdateDialogParamsChange(e, prop) {
    e.stopPropagation();
    const newUpdateDialogParams = this.state.updateDialogParams;
    newUpdateDialogParams[prop] = e.target.value;
    this.setState({ updateDialogParams: newUpdateDialogParams });
  }

  closeUpdateDialog() {
    this.setState({
      updateDialogOpen: false,
      updateDialogParams: {},
    });
  }

  async updateLine() {
    const ID = this.state.updateDialogParams.ID.trim();
    const developerId = this.state.updateDialogParams.developerId.trim();
    let developerName = "";
    const propertyName = this.state.updateDialogParams.propertyName.trim();
    const buildingNo = this.state.updateDialogParams.buildingNo.trim();
    const unit = this.state.updateDialogParams.unit.trim();
    const floor = this.state.updateDialogParams.floor.trim();
    const roomNumber = this.state.updateDialogParams.roomNumber.trim();
    const houseType = this.state.updateDialogParams.houseType.trim();
    const buildingArea = this.state.updateDialogParams.buildingArea;
    const recordPrice = this.state.updateDialogParams.recordPrice;
    const totalPrice = this.state.updateDialogParams.totalPrice;
    const maximumPrice = this.state.updateDialogParams.maximumPrice;
    const totalPrice2 = this.state.updateDialogParams.totalPrice2;
    const remarks = (this.state.updateDialogParams.remarks || '').trim();

    const developerTable = toJS(store.developerTable);
    for (let index = 0; index < developerTable.length; index++) {
      const element = developerTable[index];
      if (developerId === element.ID) {
        developerName = element.name;
        break;
      }
    }

    const chkRst = CheckHandler.checkParams([
      { key: "房源ID", value: ID, notNull: true, type: "", maxLength: 64 },
      {
        key: "房产商ID",
        value: developerId,
        notNull: true,
        type: "",
        maxLength: 64,
      },
      {
        key: "房产商名称",
        value: developerName,
        notNull: true,
        type: "",
        maxLength: 16,
      },
      {
        key: "楼盘名称",
        value: propertyName,
        notNull: true,
        type: "",
        maxLength: 16,
      },
      { key: "幢号", value: buildingNo, notNull: true, type: "", maxLength: 8 },
      { key: "单元", value: unit, notNull: true, type: "", maxLength: 8 },
      { key: "楼层", value: floor, notNull: true, type: "", maxLength: 8 },
      { key: "房号", value: roomNumber, notNull: true, type: "", maxLength: 8 },
      { key: "户型", value: houseType, notNull: true, type: "", maxLength: 16 },
      {
        key: "建筑面积(平方米)",
        value: buildingArea,
        notNull: true,
        type: "number",
        maxLength: 16,
      },
      {
        key: "备案单价(元/平方米)",
        value: recordPrice,
        notNull: true,
        type: "number",
        maxLength: 16,
      },
      {
        key: "备案总价",
        value: totalPrice,
        notNull: true,
        type: "number",
        maxLength: 16,
      },
      {
        key: "最高限价单价",
        value: maximumPrice,
        notNull: true,
        type: "number",
        maxLength: 16,
      },
      {
        key: "最高限价总价",
        value: totalPrice2,
        notNull: true,
        type: "number",
        maxLength: 16,
      },
      { key: "备注", value: remarks, notNull: false, type: "", maxLength: 64 },
    ]);
    if (chkRst.msg) {
      store.openMessageDialogOpen(chkRst.msg);
      return;
    }

    const rst = await updateRoom({
      ID,
      developerId,
      developerName,
      propertyName,
      buildingNo,
      unit,
      floor,
      roomNumber,
      houseType,
      buildingArea,
      recordPrice,
      totalPrice,
      maximumPrice,
      totalPrice2,
      remarks,
    });
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "系统错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "更新成功");
      this.closeUpdateDialog();
      store.search();
      store.clearLinesSelected();
      return true;
    }
  }

  // 定制
  async publishRoom(e, row, index) {
    //  console.log(`----- send req of publishRoom: ID:'${row.ID}'` );
    const rst = await publishRoom({ ID: row.ID });
    //  console.log(`----- publishRoom rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "发布错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "发布成功");
      store.search();
      return true;
    }
  }

  // 定制
  async recallRoom(e, row, index) {
    //  console.log(`----- send req of recallRoom: ID:'${row.ID}'` );
    const rst = await recallRoom({ ID: row.ID });
    //  console.log(`----- recallRoom rst: `, rst);
    if (rst.code === "error") {
      store.openMessageDialogOpen(rst.msg || "撤回错误");
      return true;
    } else if (rst.code === "success") {
      store.openMessageDialogOpen(rst.msg || "撤回成功");
      store.search();
      return true;
    }
  }

  render() {
    const { classes } = this.props;

    const headCells = [
      // 定制
      {
        id: "developerId",
        align: "left",
        disablePadding: false,
        label: "开发商",
        sortable: true,
      },
      {
        id: "propertyName",
        align: "left",
        disablePadding: false,
        label: "楼盘",
        sortable: true,
      },
      {
        id: "locationInfo",
        align: "left",
        disablePadding: false,
        label: "位置信息",
        sortable: false,
      },
      { id: "houseType", align: "left", disablePadding: false, label: "户型", sortable: true, },
      {
        id: "buildingArea",
        align: "left",
        disablePadding: false,
        label: "建筑面积(平方米)",
        sortable: false,
      },
      {
        id: "recordPrice",
        align: "left",
        disablePadding: false,
        label: "备案单价(元/平方米)",
        sortable: false,
      },
      {
        id: "totalPrice",
        align: "left",
        disablePadding: false,
        label: "备案总价",
        sortable: false,
      },
      {
        id: "maximumPrice",
        align: "left",
        disablePadding: false,
        label: "最高限价单价",
        sortable: false,
      },
      {
        id: "totalPrice2",
        align: "left",
        disablePadding: false,
        label: "最高限价总价",
        sortable: false,
      },
      {
        id: "state",
        align: "left",
        disablePadding: false,
        label: "状态",
        sortable: true,
      },
      {
        id: "remarks",
        align: "center",
        disablePadding: false,
        label: "备注",
        sortable: true,
      },
      {
        id: "actions",
        align: "center",
        disablePadding: false,
        label: "操作",
        sortable: false,
      },
    ];

    // const emptyRows =
    //   store.tableConfig.rowsPerPage -
    //   Math.min(
    //     store.tableConfig.rowsPerPage,
    //     store.tableCount -
    //     store.tableConfig.currentPage * store.tableConfig.rowsPerPage
    //   );

    const emptyRows = Math.max(
      0,
      store.tableConfig.rowsPerPage - store.table.length
    );

    return (
      <div className={classes.root}>
        <Paper className={classes.paper}>
          <TableContainer style={{maxHeight: this.state.tableContainerHeight}}>
            <Table
              className={classes.table}
              aria-labelledby="tableTitle"
              size={"small"}
              aria-label="enhanced table"
              id="TableOfRoom"
            >
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      indeterminate={
                        store.linesSelected.length > 0 &&
                        store.linesSelected.length < store.table.length
                      }
                      checked={
                        store.table.length > 0 &&
                        store.linesSelected.length === store.table.length
                      }
                      onChange={this.handleSelectAllClick}
                      inputProps={{ "aria-label": "select all desserts" }}
                    />
                  </TableCell>
                  {headCells.map((headCell) => (
                    <TableCell
                      key={headCell.id}
                      align={headCell.align}
                      padding="normal"
                      sortDirection={
                        store.tableConfig.orderBy === headCell.id
                          ? store.tableConfig.order
                          : false
                      }
                      className={classes.TableCell}
                    >
                      {headCell.sortable && (
                        <TableSortLabel
                          key={headCell.id}
                          active={store.tableConfig.orderBy === headCell.id}
                          direction={
                            store.tableConfig.orderBy === headCell.id
                              ? store.tableConfig.order
                              : "asc"
                          }
                          onClick={(event) =>
                            this.sortHandler(event, headCell)
                          }
                        >
                          {headCell.label}
                          {store.tableConfig.orderBy === headCell.id ? (
                            <span className={classes.visuallyHidden}>
                              {store.tableConfig.order === "desc"
                                ? "sorted descending"
                                : "sorted ascending"}
                            </span>
                          ) : null}
                        </TableSortLabel>
                      )}

                      {!headCell.sortable && (
                        <TableSortLabel hideSortIcon>
                          {headCell.label}
                        </TableSortLabel>
                      )}
                    </TableCell>
                  ))}
                </TableRow>
              </TableHead>

              <TableBody key="TableBody-body">
                {this.stableSort(
                  store.table,
                  this.getComparator(
                    store.tableConfig.order,
                    store.tableConfig.orderBy
                  )
                ).map((row, index) => {
                  if (!row.buildingNo) return <></>;
                  const isItemSelected = this.isSelected(row.ID);
                  const labelId = `enhanced-table-checkbox-${index}`;
                  let developerName = "";
                  for (
                    let index = 0;
                    index < store.developerTable.length;
                    index++
                  ) {
                    const element = store.developerTable[index];
                    if (element.ID === row.developerId) {
                      developerName = element.name;
                      break;
                    }
                  }
                  return (
                    <TableRow hover tabIndex={-1} key={`TableRow-${labelId}`}>
                      <TableCell padding="checkbox">
                        <Checkbox
                          key={row.uid}
                          checked={isItemSelected}
                          inputProps={{ "aria-labelledby": labelId }}
                          onClick={(event) =>
                            this.handleCheckClick(event, row.ID)
                          }
                          className={classes.TableCell}
                        />
                      </TableCell>
                      <TableCell
                        component="th"
                        align="left"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className={classes.TableCell}
                      >
                        {developerName}
                      </TableCell>
                      <TableCell
                        component="th"
                        align="left"
                        id={labelId}
                        scope="row"
                        padding="normal"
                        className={classes.TableCell}
                      >
                        {row.propertyName}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.locationInfo}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.houseType}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.buildingArea}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.recordPrice}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.totalPrice}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.maximumPrice}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {row.totalPrice2}
                      </TableCell>
                      <TableCell align="left" className={classes.TableCell}>
                        {
                          ["", "未发布", "已发布", "销售中", "已销售"][
                          row.state
                          ]
                        }
                      </TableCell>
                      <TableCell
                        align="left"
                        className={classes.TableCell}
                        style={{ maxWidth: "200px" }}
                      >
                        {row.remarks}
                      </TableCell>
                      <TableCell
                        align="center"
                        style={{ width: "130px" }}
                        className={classes.TableCell}
                      >
                        <ButtonGroup
                          variant="contained"
                          aria-label="contained primary button group"
                        >
                          {getIfFuncAuthorized("房票管理-开发商房源管理-修改")
                            && (
                              <Button
                                color="primary"
                                onClick={(e) => this.openUpdateLineDialog(e, row)}
                                disabled={!(row.state === "1")}
                              >
                                修改
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-开发商房源管理-删除")
                            && (
                              <Button
                                color="secondary"
                                disabled={!(row.state === "1")}
                                onClick={(e) => this.openDeleteLineDialog(e, row.ID)}
                              >
                                删除
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-开发商房源管理-发布")
                            && (
                              <Button
                                color="primary"
                                disabled={!(row.state === "1")}
                                onClick={(e) => this.publishRoom(e, row, index)}
                              >
                                发布
                              </Button>
                            )}
                          {getIfFuncAuthorized("房票管理-开发商房源管理-撤回")
                            && (
                              <Button
                                color="primary"
                                disabled={!(row.state === "2")}
                                onClick={(e) => this.recallRoom(e, row, index)}
                              >
                                撤回
                              </Button>
                            )}
                        </ButtonGroup>
                      </TableCell>
                    </TableRow>
                  );
                })}
                {emptyRows > 0 && (
                  <TableRow style={{ height: 74 * emptyRows }}>
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            rowsPerPageOptions={[10, 20, 40]}
            component="div"
            count={store.tableCount}
            rowsPerPage={store.tableConfig.rowsPerPage}
            page={store.tableConfig.currentPage}
            onPageChange={this.handleChangePage}
            onRowsPerPageChange={this.handleChangeRowsPerPage}
          />
        </Paper>

        <Dialog
          open={this.state.updateDialogOpen}
          onClose={(e) => this.closeUpdateDialog(e)}
          aria-labelledby="form-dialog-title"
        >
          <DialogTitle id="updateDialog">修改房源信息</DialogTitle>
          <DialogContent>
            <FormControl fullWidth>
              <InputLabel
                id="developer-simple-select-outlined-label"
                style={{ marginTop: "-8px" }}
              >
                *房产商名称
              </InputLabel>
              <Select
                labelId="developer-simple-select-outlined-label"
                id="developerId"
                value={this.state.updateDialogParams.developerId || ""}
                onChange={(e) =>
                  this.onUpdateDialogParamsChange(e, "developerId")
                }
                label="房产商名称"
                margin="dense"
              >
                <MenuItem value="">
                  <em>请选择</em>
                </MenuItem>
                {store.developerTable.map((row) => {
                  const ID = row.ID;
                  const name = row.name;
                  return (
                    <MenuItem value={ID} key={ID}>
                      {name}
                    </MenuItem>
                  );
                })}
              </Select>
            </FormControl>
            <ITextField
              autoFocus
              margin="dense"
              id="propertyName"
              label="*楼盘名称"
              fullWidth
              ivalue={this.state.updateDialogParams.propertyName || ""}
              onChange={(e) =>
                this.onUpdateDialogParamsChange(e, "propertyName")
              }
              type=""
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="buildingNo"
              label="*幢号"
              fullWidth
              ivalue={this.state.updateDialogParams.buildingNo || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "buildingNo")}
              type=""
              maxLength="8"
              notNull
            />
            <ITextField
              margin="dense"
              id="unit"
              label="*单元"
              fullWidth
              ivalue={this.state.updateDialogParams.unit || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "unit")}
              type=""
              maxLength="8"
              notNull
            />
            <ITextField
              margin="dense"
              id="floor"
              label="*楼层"
              fullWidth
              ivalue={this.state.updateDialogParams.floor || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "floor")}
              type=""
              maxLength="8"
              notNull
            />
            <ITextField
              margin="dense"
              id="roomNumber"
              label="*房号"
              fullWidth
              ivalue={this.state.updateDialogParams.roomNumber || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "roomNumber")}
              type=""
              maxLength="8"
              notNull
            />
            <ITextField
              margin="dense"
              id="houseType"
              label="*户型"
              fullWidth
              ivalue={this.state.updateDialogParams.houseType || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "houseType")}
              type=""
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="buildingArea"
              label="*建筑面积(平方米)"
              fullWidth
              ivalue={this.state.updateDialogParams.buildingArea || ""}
              onChange={(e) =>
                this.onUpdateDialogParamsChange(e, "buildingArea")
              }
              type="number"
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="recordPrice"
              label="*备案单价(元/平方米)"
              fullWidth
              ivalue={this.state.updateDialogParams.recordPrice || ""}
              onChange={(e) =>
                this.onUpdateDialogParamsChange(e, "recordPrice")
              }
              type="number"
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="totalPrice"
              label="*备案总价"
              fullWidth
              ivalue={this.state.updateDialogParams.totalPrice || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "totalPrice")}
              type="number"
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="maximumPrice"
              label="*最高限价单价"
              fullWidth
              ivalue={this.state.updateDialogParams.maximumPrice || ""}
              onChange={(e) =>
                this.onUpdateDialogParamsChange(e, "maximumPrice")
              }
              type="number"
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="totalPrice2"
              label="*最高限价总价"
              fullWidth
              ivalue={this.state.updateDialogParams.totalPrice2 || ""}
              onChange={(e) =>
                this.onUpdateDialogParamsChange(e, "totalPrice2")
              }
              type="number"
              maxLength="16"
              notNull
            />
            <ITextField
              margin="dense"
              id="remarks"
              label="备注"
              fullWidth
              ivalue={this.state.updateDialogParams.remarks || ""}
              onChange={(e) => this.onUpdateDialogParamsChange(e, "remarks")}
              type=""
              maxLength="64"
            />
          </DialogContent>
          <DialogActions>
            <Button
              onClick={(e) => this.updateLine(e)}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              确认修改
            </Button>
            <Button
              onClick={(e) => this.closeUpdateDialog(e)}
              color="primary"
              variant="contained"
              aria-label="contained primary button group"
            >
              取消
            </Button>
          </DialogActions>
        </Dialog>

        <Dialog
          open={this.state.deleteLineDialogOpen}
          onClose={this.closeDeleteLineDialog}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title" style={{width: '400px'}}>
            {"确认删除？"}
          </DialogTitle>
          <DialogActions>
            <Button onClick={this.deleteLine} color="secondary">
              确认删除
            </Button>
            <Button onClick={this.closeDeleteLineDialog} color="primary" autoFocus>
              取消
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

const TableOfRoomManagement = observer(TableOfRoomManagementInner);

TableOfRoomManagement.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(TableOfRoomManagement);
